// @flow
import type { TypedActionWithPayload } from '../../../types/redux';

export const LIVE_ASK_CHANGED = 'LIVE_ASK_CHANGED';
export type LIVE_ASK_CHANGED_ACTION = TypedActionWithPayload<
    typeof LIVE_ASK_CHANGED,
    {
        ask: number,
        catalogId: number,
        created: number,
        currency: string,
        increment: number,
        itemId: number,
        itemIndex: number,
        lotNumber: string,
    }
>;
export const LIVE_AUCTION_ENDED = 'LIVE_AUCTION_ENDED';
export type LIVE_AUCTION_ENDED_ACTION = TypedActionWithPayload<
    typeof LIVE_AUCTION_ENDED,
    { catalogId: number, created: number }
>;
export const LIVE_AUCTION_LOADED = 'LIVE_AUCTION_LOADED';
export type LIVE_AUCTION_LOADED_ACTION = TypedActionWithPayload<
    typeof LIVE_AUCTION_LOADED,
    { catalogId: number, created: number, serverId: number }
>;
export const LIVE_AUCTION_MOVED = 'LIVE_AUCTION_MOVED';
export type LIVE_AUCTION_MOVED_ACTION = TypedActionWithPayload<
    typeof LIVE_AUCTION_MOVED,
    { catalogId: number, created: number }
>;
export const LIVE_AUCTION_OPENED = 'LIVE_AUCTION_OPENED';
export type LIVE_AUCTION_OPENED_ACTION = TypedActionWithPayload<
    typeof LIVE_AUCTION_OPENED,
    { catalogId: number, created: number, serverId: number }
>;
export const LIVE_AUCTION_PAUSED = 'LIVE_AUCTION_PAUSED';
export type LIVE_AUCTION_PAUSED_ACTION = TypedActionWithPayload<
    typeof LIVE_AUCTION_PAUSED,
    { catalogId: number, created: number }
>;
export const LIVE_AUCTION_RESUMED = 'LIVE_AUCTION_RESUMED';
export type LIVE_AUCTION_RESUMED_ACTION = TypedActionWithPayload<
    typeof LIVE_AUCTION_RESUMED,
    { catalogId: number, created: number }
>;
export const LIVE_AUCTION_STARTED = 'LIVE_AUCTION_STARTED';
export type LIVE_AUCTION_STARTED_ACTION = TypedActionWithPayload<
    typeof LIVE_AUCTION_STARTED,
    { catalogId: number, created: number }
>;
export const LIVE_BID_ACCEPTED = 'LIVE_BID_ACCEPTED';
export type LIVE_BID_ACCEPTED_ACTION = TypedActionWithPayload<
    typeof LIVE_BID_ACCEPTED,
    {
        amount: number,
        ask: number,
        assignedId: number,
        bidderId: number,
        catalogId: number,
        created: number,
        currency: string,
        increment: number,
        itemId: number,
        itemIndex: number,
        lotNumber: string,
        myBid: boolean,
        source: string,
    }
>;
export const LIVE_BID_RETRACTED = 'LIVE_BID_RETRACTED';
export type LIVE_BID_RETRACTED_ACTION = TypedActionWithPayload<
    typeof LIVE_BID_RETRACTED,
    {
        amount: number,
        ask: number,
        assignedId: number,
        bidderId: number,
        catalogId: number,
        created: number,
        currency: string,
        increment: number,
        itemId: number,
        itemIndex: number,
        lotNumber: string,
        source: string,
    }
>;
export const LIVE_LOT_CLOSED = 'LIVE_LOT_CLOSED';
export type LIVE_LOT_CLOSED_ACTION = TypedActionWithPayload<
    typeof LIVE_LOT_CLOSED,
    {
        catalogId: number,
        created: number,
        itemId: number,
        lotNumber: string,
    }
>;
export const LIVE_LOT_PASSED = 'LIVE_LOT_PASSED';
export type LIVE_LOT_PASSED_ACTION = TypedActionWithPayload<
    typeof LIVE_LOT_PASSED,
    {
        catalogId: number,
        created: number,
        itemId: number,
        lotNumber: string,
    }
>;
export const LIVE_LOT_REOPENED = 'LIVE_LOT_REOPENED';
export type LIVE_LOT_REOPENED_ACTION = TypedActionWithPayload<
    typeof LIVE_LOT_REOPENED,
    {
        catalogId: number,
        created: number,
        itemId: number,
        lotNumber: string,
    }
>;
export const LIVE_LOT_SKIPPED = 'LIVE_LOT_SKIPPED';
export type LIVE_LOT_SKIPPED_ACTION = TypedActionWithPayload<
    typeof LIVE_LOT_SKIPPED,
    {
        catalogId: number,
        created: number,
        itemId: number,
        lotNumber: string,
        newLotNumber: string,
    }
>;
export const LIVE_LOT_SOLD = 'LIVE_LOT_SOLD';
export type LIVE_LOT_SOLD_ACTION = TypedActionWithPayload<
    typeof LIVE_LOT_SOLD,
    {
        amount: number,
        assignedId: number,
        bidderId: number,
        catalogId: number,
        created: number,
        currency: string,
        itemId: number,
        lotNumber: string,
        myBid: boolean,
        source: string,
    }
>;
export const LIVE_LOT_UNSOLD = 'LIVE_LOT_UNSOLD';
export type LIVE_LOT_UNSOLD_ACTION = TypedActionWithPayload<
    typeof LIVE_LOT_UNSOLD,
    {
        catalogId: number,
        created: number,
        itemId: number,
        lotNumber: string,
    }
>;
export const LIVE_MISSIVE = 'LIVE_MISSIVE';
export type LIVE_MISSIVE_ACTION = TypedActionWithPayload<
    typeof LIVE_MISSIVE,
    {
        catalogId: number,
        created: number,
        itemId: number,
        missiveText: string,
    }
>;
export const LIVE_NETWORK_DISCONNECTED = 'LIVE_NETWORK_DISCONNECTED';
export const LIVE_NETWORK_RECONNECTED = 'LIVE_NETWORK_RECONNECTED';
export const LIVE_NEXT_LOT_LOADED = 'LIVE_NEXT_LOT_LOADED';
export type LIVE_NEXT_LOT_LOADED_ACTION = TypedActionWithPayload<
    typeof LIVE_NEXT_LOT_LOADED,
    {
        askPrice: number,
        catalogId: number,
        created: number,
        currency: string,
        description: string,
        highEstimate: number,
        increment: number,
        index: number,
        itemId: number,
        itemIndex: number,
        lotNumber: string,
        lotTitle: string,
        lowEstimate: number,
        pendingAssignedId: number,
        pendingBid: number,
        status: string,
    }
>;
export const LIVE_NEXT_LOT_OPENED = 'LIVE_NEXT_LOT_OPENED';
export type LIVE_NEXT_LOT_OPENED_ACTION = TypedActionWithPayload<
    typeof LIVE_NEXT_LOT_OPENED,
    {
        catalogId: number,
        created: number,
        currency: string,
        itemId: number,
        lotNumber: string,
    }
>;

export const LIVE_UPDATE_ACTIVE_BIDDERS_PUBNUB = 'LIVE_UPDATE_ACTIVE_BIDDERS_PUBNUB';
export const LIVE_UPDATE_ACTIVE_BIDDERS_SFS = 'LIVE_UPDATE_ACTIVE_BIDDERS_SFS';
